import React from 'react';

const WaveAnimation = ({ 
  color = '#ffffff', 
  opacity = 0.1, 
  speed = 20, 
  height = 100,
  position = 'bottom',
  waveCount = 3 
}) => {
  const waveElements = Array.from({ length: waveCount }, (_, index) => {
    const delay = index * 2; // Stagger the animations
    const duration = speed + (index * 5); // Vary the speed slightly
    
    return (
      <div
        key={index}
        className="absolute left-0 w-full overflow-hidden"
        style={{
          [position]: 0,
          height: `${height}px`,
          zIndex: 1,
        }}
      >
        <div
          className="absolute w-[200%] h-full"
          style={{
            left: '-100%',
            background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z' fill='${encodeURIComponent(color)}' fill-opacity='${opacity}'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'repeat-x',
            backgroundSize: '1200px 120px',
            animation: `wave ${duration}s linear infinite`,
            animationDelay: `${delay}s`,
          }}
        />
      </div>
    );
  });

  return (
    <div
      className="absolute left-0 w-full overflow-hidden"
      style={{
        [position]: 0,
        height: `${height}px`,
        zIndex: 1,
      }}
    >
      {waveElements}
      <style>{`
        @keyframes wave {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </div>
  );
};

export default WaveAnimation;
